import React from 'react';
import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const ViewTeachingOrderSections = ({ section }) => {
  const classes = useStyles();

  return (
    <Box display="flex" flexDirection="column">
      <Typography className={classes.lessonTitle}>{section.title}</Typography>
      <ul style={{ padding: 0, marginLeft: 0, listStyle: 'none' }}>
        {section.activities?.map((activity, i) => (
          <li key={`${i}-activityList`} style={{ marginBottom: '15px', lineHeight: 1.2 }}>
            <span className={classes.assignments}>{activity?.title}</span>
          </li>
        ))}
      </ul>
    </Box>
  );
};

const useStyles = makeStyles(() => ({
  lessonTitle: {
    marginTop: '5px',
    fontSize: '12px',
    marginBottom: '7px'
  },
  assignments: {
    display: 'flex',
    flex: 1,
    justifyContent: 'space-between',
    fontSize: '12px',
    color: '#454545',
    fontWeight: 300
  }
}));
